import { useEffect } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';

const useQueries = (): [any, Function] => {
  const [searchParams, setSearchParams] = useSearchParams();
  const navigate = useNavigate();

  // Lấy đối tượng truy vấn từ URL
  const queries: Record<string, any> = Object.fromEntries(searchParams.entries());

  // Hàm để cập nhật đối tượng truy vấn và đẩy nó vào URL
  const setQueries: Function = (newQuery: Record<string, any> | ((_: Record<string, any>) => Record<string, any>)) => {
    if (typeof newQuery === 'function') {
      const updatedState = newQuery(queries);
      const newState = typeof updatedState === 'object' ? updatedState : {};
      setSearchParams(new URLSearchParams(newState));
    } else {
      setSearchParams(new URLSearchParams(newQuery));
      navigate(`?${new URLSearchParams(newQuery).toString()}`);
    }
  };

  useEffect(() => {
    // Kiểm tra nếu có các tham số truy vấn không hợp lệ
    // và chuyển hướng đến một URL hợp lệ
    // if (Object.keys(queries).length === 0 && window.location.search) {
    //   console.log('🚀 ~ file: useQueries.ts:33 ~ useEffect ~ window.location.search:', window.location.search);
    //   navigate('/');
    // }
  }, [queries, navigate]);

  return [queries, setQueries];
};

export default useQueries;
